module.exports = __webpack_public_path__ + "static/img/tubiao_1.8393de2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/assets/tubiao_1.jpg
// module id = JksQ
// module chunks = 1